import store from '@/store';
// import moment from "moment";
import consts from "@/consts";
import {getMainParentRouteName} from "@/lib/lib";
import {liteTemplate} from "@/lib/routes";

const unitHwTypeTransformation = consts.unitHwTypeTransformationToRoute
const unitTypeTransformation = consts.unitTypeTransformationToRoute

function getUnitDefaultRouteParams(unitId, template) {
    let unit = store.getters.getUnitsByIds[unitId]
    if(unit?.id) localStorage.setItem(store.getters.getUserStorageKey + '.unit.active', unitId);
    template = template
        || unitHwTypeTransformation?.[unit?.hw_type]?.type?.[unit?.type]
        || unitHwTypeTransformation?.[unit?.hw_type]?.template
        || unitTypeTransformation[unit?.type]
        || unit?.hw_type

    let routeName = consts.routerNames?.units?.type[template]

    //if(store.getters.isUnitsFullLoad){
    if (!routeName) {
        if (unit?.video) {
            template = 'xvision'
            routeName = consts.routerNames?.units?.type?.xvision
        } else if (unit?.reefer_type) {
            template = 'xcool'
            routeName = consts.routerNames?.units?.type?.xcool
        } else {
            template = 'xtrack'
            routeName = consts.routerNames?.units?.type?.xtrack
        }
    }
    //}
    if (!unitId) routeName = consts.routerNames.units

    return {
        routeName,
        params: {
            unitId,
            template
        }
    }
}

function clearQueryFilter(query) {
    delete query.hideEvents
    return query
}

const defaultSetRoute = {
    units: (route, router) => {
        if (getMainParentRouteName(route.meta?.mainRouteName) !== consts.routerNames.units.main) {
            if (consts.app.$isDevelopment) console.warn('units', route);
            return false;
        }
        router.push({
            name: consts.routerNames.units.main,
            params: {},
            query: {}
        })
    },
    returnToParent: (route, router) => {
        if (getMainParentRouteName(route.meta?.mainRouteName) !== consts.routerNames.units.main) {
            if (consts.app.$isDevelopment) console.warn(consts.routerNames.units.main + ' returnToParent', route);
            return false;
        }
        let name = route.meta?.parentRouteName || consts.routerNames.units.main;
        let query = clearQueryFilter(route.query)
        router.push({
            name: name,
            params: {
                ...route.params,
            },
            query
        })
    },
    unitsAll: (route, router) => {
        if (getMainParentRouteName(route.meta?.mainRouteName) !== consts.routerNames.units.main) {
            if (consts.app.$isDevelopment) console.warn('units', route);
            return false;
        }
        let query = clearQueryFilter(route.query)
        router.push({
            name: consts.routerNames.units.all.main,
            params: {},
            query
        })
    },
    unitId: (route, router, unitId, date, template) => {
        if (getMainParentRouteName(route.meta?.mainRouteName) !== consts.routerNames.units.main) {
            if (consts.app.$isDevelopment) console.warn('unitId', route);
            return false;
        }
        if (store.getters?.getUnitsOnMap?.length) {
            store.commit('setUnitsShowOnMap', {
                showOnMap: false,
                unitIds: store.getters?.getUnitsOnMap
            })
        }
        let routeParams = getUnitDefaultRouteParams(unitId, template)
        let query = clearQueryFilter(route.query)
        date = date || route?.params?.date || store.getters.getDateToday
        router.push({
            name: routeParams.routeName.date,
            params: {
                ...routeParams?.params,
                date,
            },
            query
        })
    },
    liteTemplate,
    unitEdit: (route, router, unitId) => {
        if (getMainParentRouteName(route.meta?.mainRouteName) !== consts.routerNames.units.main) {
            if (consts.app.$isDevelopment) console.warn('unitEdit', route);
            return false;
        }
        let routeParams = getUnitDefaultRouteParams(unitId)
        router.push({
            name: routeParams.routeName.edit,
            params: {
                ...route.params,
                unitId,
            },
            query: {...route.query}
        })

    },
    unitInfo: (route, router, unitId) => {
        if (getMainParentRouteName(route.meta?.mainRouteName) !== consts.routerNames.units.main) {
            if (consts.app.$isDevelopment) console.warn('unitInfo', route);
            return false;
        }
        let routeParams = getUnitDefaultRouteParams(unitId)
        router.push({
            name: routeParams?.routeName.info,
            params: {
                ...routeParams?.params,
            },
            query: {...route.query}
        })
    },
    unitsAllUnitInfo: (route, router, unitId) => {
        if (getMainParentRouteName(route.meta?.mainRouteName) !== consts.routerNames.units.main) {
            if (consts.app.$isDevelopment) console.warn('unitInfo', route);
            return false;
        }
        router.push({
            name: consts.routerNames.units.all.info,
            params: {
                unitId,
            },
            query: {...route.query}
        })
    },
    timeCapsuleDate: (route, router, unitId, date) => {
        if (getMainParentRouteName(route.meta?.mainRouteName) !== consts.routerNames.units.main) {
            if (consts.app.$isDevelopment) console.warn('timeCapsuleDate', route);
            return false;
        }
        date = date || store.getters.getDateToday
        let params = {
            ...route.params,
            date,
        }

        router.push({
            name: consts.routerNames.units.type.xvision.timeCapsule.date,
            params,
            query: {...route.query}
        })
    },
    timeCapsuleVideo: (route, router, eventXid, date) => {
        if (getMainParentRouteName(route.meta?.mainRouteName) !== consts.routerNames.units.main) {
            if (consts.app.$isDevelopment) console.warn('timeCapsuleVideo', route);
            return false;
        }
        date = date || route.params?.date || store.getters.getDateToday
        let params = {
            ...route.params,
            date,
            eventXid,
        }

        router.push({
            name: consts.routerNames.units.type.xvision.timeCapsule.video,
            params,
            query: {...route.query}
        })
    },
    unitReefer: (route, router, unitId) => {
        if (getMainParentRouteName(route.meta?.mainRouteName) !== consts.routerNames.units.main) {
            if (consts.app.$isDevelopment) console.warn('unitReefer', route);
            return false;
        }
        router.push({
            name: consts.routerNames.units.type.xcool.reefer,
            params: {
                unitId,
            },
            query: {...route.query}
        })
    },
    unitStationAnalytics: (route, router, unitId, name) => {
        if (getMainParentRouteName(route.meta?.mainRouteName) !== consts.routerNames.units.main) {
            if (consts.app.$isDevelopment) console.warn('unitStationAnalytics', route);
            return false;
        }
        let routeParams = getUnitDefaultRouteParams(unitId)
        router.push({
            name: routeParams.routeName[name],
            params: {
                ...routeParams.params
            },
            query: {...route.query}
        })
    },
    unitGenerator: (route, router, unitId, name) => {
        if (getMainParentRouteName(route.meta?.mainRouteName) !== consts.routerNames.units.main) {
            if (consts.app.$isDevelopment) console.warn('unitGenerator', route);
            return false
        }
        let routeParams = getUnitDefaultRouteParams(unitId)
        router.push({
            name: routeParams?.routeName[name],
            params: {
                ...routeParams.params,
            },
            query: {...route.query}
        })
    },
    unitsFilter: (route, router, filter) => {
        if (getMainParentRouteName(route.meta?.mainRouteName) !== consts.routerNames.units.main) {
            if (consts.app.$isDevelopment) console.warn('unitsFilter', route);
            return false
        }
        let unitId = +route.params?.unitId
        let eventXid = route.params?.eventXid
        router.push({
            name: route.name,
            params: {
                unitId,
                eventXid,
            },
            query: {...filter}
        })
    },
    liveVideo: (route, router, unitId) => {
        if (getMainParentRouteName(route.meta?.mainRouteName) !== consts.routerNames.units.main) {
            if (consts.app.$isDevelopment) console.warn('liveVideo', route);
            return false
        }
        let routeParams = getUnitDefaultRouteParams(unitId)
        let query = clearQueryFilter(route.query)
        router.push({
            name: routeParams.routeName.liveVideo,
            params: {
                ...routeParams.params
            },
            query
        })
    },
    unitSnapshots: (route, router, unitId, date, eventXid) => {
        if (getMainParentRouteName(route.meta?.mainRouteName) !== consts.routerNames.units.main) {
            if (consts.app.$isDevelopment) console.warn('unitId', route);
            return false;
        }
        let isLite = route.name.split('.').includes('lite')
        let noList = route.params.noList
        let routeParams = getUnitDefaultRouteParams(unitId)
        let query = clearQueryFilter(route.query)
        router.push({
            name: routeParams?.routeName?.snapshots + (isLite ? '.lite' : ''),
            params: {
                ...routeParams.params,
                unitId,
                date,
                eventXid,
                noList
            },
            query
        })
    },
    command: (route, router, unitId, eventXid) => {
        if (getMainParentRouteName(route.meta?.mainRouteName) !== consts.routerNames.units.main) {
            if (consts.app.$isDevelopment) console.warn('event', route);
            return false
        }
        console.log(router, unitId, eventXid);
        return false;
        // let isLite = route.name?.split('.')?.includes('lite');
        // let noList = route?.params?.noList
        // let routeParams = getUnitDefaultRouteParams(unitId)
        // let query = clearQueryFilter(route.query)
        // router.push({
        //     name: routeParams?.routeName?.event + (isLite ? '.lite' : ''),
        //     params: {
        //         ...routeParams.params,
        //         eventXid,
        //         noList
        //     },
        //     query
        // })
    },
    event: (route, router, unitId, eventXid) => {
        if (getMainParentRouteName(route.meta?.mainRouteName) !== consts.routerNames.units.main) {
            if (consts.app.$isDevelopment) console.warn('event', route);
            return false
        }
        let isLite = route.name?.split('.')?.includes('lite');
        let noList = route?.params?.noList
        let routeParams = getUnitDefaultRouteParams(unitId)
        let query = clearQueryFilter(route.query)
        router.push({
            name: routeParams?.routeName?.event + (isLite ? '.lite' : ''),
            params: {
                ...routeParams.params,
                eventXid,
                noList
            },
            query
        })
    },
    'video-event': (route, router, unitId, eventXid) => {
        if (getMainParentRouteName(route.meta?.mainRouteName) !== consts.routerNames.units.main) {
            if (consts.app.$isDevelopment) console.warn('video-event', route);
            return false
        }
        let isLite = route.name?.split('.')?.includes('lite');
        let noList = route?.params?.noList
        let routeParams = getUnitDefaultRouteParams(unitId)
        let query = clearQueryFilter(route.query)
        router.push({
            name: routeParams?.routeName?.videoEvent + (isLite ? '.lite' : ''),
            params: {
                ...routeParams.params,
                eventXid,
                noList
            },
            query
        })
    },
    'video-request': (route, router, unitId, eventXid) => {
        if (getMainParentRouteName(route.meta?.mainRouteName) !== consts.routerNames.units.main) {
            if (consts.app.$isDevelopment) console.warn('video-request', route);
            return false
        }
        let isLite = route.name.split('.').includes('lite')
        let noList = route.params.noList
        let routeParams = getUnitDefaultRouteParams(unitId)
        let query = clearQueryFilter(route.query)
        router.push({
            name: routeParams.routeName.videoRequest + (isLite ? '.lite' : ''),
            params: {
                ...routeParams.params,
                eventXid,
                noList
            },
            query
        })
    },
    fastGeoitem: (route, router, unitId) => {
        if (getMainParentRouteName(route.meta?.mainRouteName) !== consts.routerNames.units.main) {
            if (consts.app.$isDevelopment) console.warn('fastGeoitem', route);
            return false
        }
        let routeParams = getUnitDefaultRouteParams(unitId)
        router.push({
            name: routeParams.routeName.fastGeozone,
            params: {
                ...routeParams.params,
            },
            query: {...route.query}
        })
    },
    track: (route, router, unitId, date = store.getters.getDateToday) => {
        if (getMainParentRouteName(route.meta?.mainRouteName) !== consts.routerNames.units.main) {
            if (consts.app.$isDevelopment) console.warn('track', route);
            return false
        }
        let unit = store.getters.getUnitsByIds[unitId];
        let name = consts.routerNames.tracks.unit.main;
        if(consts.typesForTrackByPoints.includes(unit?.type)) {
            name = consts.routerNames.tracks.unit.asset.main
        }
        router.push({
            name,
            params: {
                unitId,
                date,
            },
            query: {}
        })
    },
    unitTrackXid: (route, router, date, type, trackXid, timeFrom, timeTo, trackColor, filter) => {
        if (getMainParentRouteName(route.meta?.mainRouteName) !== consts.routerNames.units.main) {
            if (consts.app.$isDevelopment) console.warn('trackXid', route);
            return false
        }
        let unitId = route?.params?.unitId
        let template = route?.params?.template
        let routeParams = getUnitDefaultRouteParams(unitId, template)
        trackColor = trackColor ? 'track-color' : ''
        router.push({
            name: routeParams.routeName.track,
            params: {
                ...routeParams.params,
                date,
                type,
                trackXid,
                timeFrom,
                timeTo,
                trackColor,
            },
            query: {
                ...route.query,
                ...filter,
            }
        })
    },
    unitCommand: (route, router, unitId) => {
        if (getMainParentRouteName(route.meta?.mainRouteName) !== consts.routerNames.units.main) {
            if (consts.app.$isDevelopment) console.warn('unitCommand', route);
            return false
        }
        router.push({
            name: consts.routerNames.units.commands.main,
            params: {
                unitId,
            },
            query: {...route.query}
        })
    },
    unitsGroupCommand: (route, router, groupId) => {
        if (getMainParentRouteName(route.meta?.mainRouteName) !== consts.routerNames.units.main) {
            if (consts.app.$isDevelopment) console.warn('unitsGroupCommand', route);
            return false
        }
        router.push({
            name: consts.routerNames.units.commands.group,
            params: {
                groupId,
            },
            query: {...route.query}
        })
    },
    unitsLocator: (route, router, unitId) => {
        if (getMainParentRouteName(route.meta?.mainRouteName) !== consts.routerNames.units.main) {
            if (consts.app.$isDevelopment) console.warn('unitsLocator', route);
            return false
        }
        router.push({
            name: consts.routerNames.units.locator,
            params: {
                unitId,
            },
            query: {...route.query}
        })
    },
    unitChat: (route, router, unitId) => {
        if (getMainParentRouteName(route.meta?.mainRouteName) !== consts.routerNames.units.main) {
            if (consts.app.$isDevelopment) console.warn('unitChat', route);
            return false
        }
        router.push({
            name: consts.routerNames.units.chat,
            params: {
                unitId,
            },
            query: {...route.query}
        })
    },
    unitAOVXSwitch: (route, router, unitId, routeName) => {
        if (getMainParentRouteName(route.meta?.mainRouteName) !== consts.routerNames.units.main) {
            if (consts.app.$isDevelopment) console.warn('unitAOVXSwitch', route);
            return false;
        }
        router.push({
            name: routeName,
            params: {
                ...route.params,
                unitId,
            },
            query: {...route.query}
        })
    },
    unitChangePrams: (route, router, params = {}, query = {}) => {
        if (getMainParentRouteName(route.meta?.mainRouteName) !== consts.routerNames.units.main) {
            if (consts.app.$isDevelopment) console.warn('unitChangePrams', route);
            return false;
        }
        router.push({
            name: route.name,
            params: {
                ...route.params,
                ...params,
            },
            query: {...route.query, ...query}
        })
    },
    setQueryParams: (route, router, query) => {
        if (getMainParentRouteName(route.meta?.mainRouteName) !== consts.routerNames.units.main) {
            if (consts.app.$isDevelopment) console.warn('setQueryParams', route);
            return false;
        }
        router.push({
            name: route.name,
            params: {
                ...route.params,
            },
            query
        })
    },
    smartSearch: (route, router, filter = {}, query = {}) => {
        if (getMainParentRouteName(route.meta?.mainRouteName) !== consts.routerNames.units.main) {
            if (consts.app.$isDevelopment) console.warn('smartSearch', route);
            return false;
        }
        router.push({
            name: consts.routerNames.units.type.xvision.smartSearch.main,
            params: {
                ...route.params,
                ...filter,
            },
            query: {
                ...query
            }
        })
    },
    smartSearchRequest: (route, router, unitId, eventXid) => {
        if (getMainParentRouteName(route.meta?.mainRouteName) !== consts.routerNames.units.main) {
            if (consts.app.$isDevelopment) console.warn('video-request', route);
            return false
        }
        let isLite = route.name.split('.').includes('lite')
        let noList = route.params.noList
        router.push({
            name: consts.routerNames.units.type.xvision.smartSearch.videoRequest + (isLite ? '.lite' : ''),
            params: {
                unitId,
                eventXid,
                noList
            },
            query: {...route.query}
        })
    },
    obdMap: (route, router, unitId) => {
        if (getMainParentRouteName(route.meta?.mainRouteName) !== consts.routerNames.units.main) {
            if(consts.app.$isDevelopment) console.warn('obdMap', route);
            return false;
        }
        if(store.getters?.getUnitsOnMap?.length) {
            store.commit('setUnitsShowOnMap', {
                showOnMap: false,
                unitIds: store.getters?.getUnitsOnMap
            })
        }

        let routeParams = getUnitDefaultRouteParams(unitId)

        router.push({
            name: routeParams?.routeName.map,
            params: {
                ...routeParams?.query,
            },
            query: {...route.query}
        })
    },

    switchTemplate: (route, router, template, params={}) => {
        if (getMainParentRouteName(route.meta?.mainRouteName) !== consts.routerNames.units.main) {
            if(consts.app.$isDevelopment) console.warn('switchTemplate', route);
            return false;
        }

        let unitId = route?.params?.unitId
        router.push({
            name: consts.routerNames?.units?.type[template]?.main,
            params: {
                unitId,
                template,
                ...params
            },
            query: {...route.query}
        })
    },
    xblesUnitId: (route, router, unitId, tagId) => {
        if (getMainParentRouteName(route.meta?.mainRouteName) !== consts.routerNames.units.main) {
            if (consts.app.$isDevelopment) console.warn('unitId', route);
            return false;
        }
        let query = clearQueryFilter(route.query)
        let name = tagId ? consts.routerNames?.units?.type?.xbles?.id?.main : consts.routerNames?.units?.type?.xbles?.main
        router.push({
            name,
            params: {
                unitId,
                template: 'xbles',
                tagId,
            },
            query
        })
    },
    unitsSharedLink: (route, router, unitId) => {
        if (getMainParentRouteName(route.meta?.mainRouteName) !== consts.routerNames.units.main) {
            if(consts.app.$isDevelopment) console.warn('SharedLink', route);
            return false
        }
        let routeParams = getUnitDefaultRouteParams(unitId)
        router.push({
            name: routeParams?.routeName.sharedLinks,
            params: {
                ...route.params,
                unitId,
            },
            query: {
                ...route.query
            }
        })
    },

}

function replaceParams(route) {
    let unitId = route?.params?.unitId
    // let unit = store.getters.getUnitsByIds[unitId]
    // if(unitId && unit?.hw_type == 'xtag' && unit?.parent__id) {
    //     unitId = unit?.parent__id
    // }
    return {...route?.params, unitId}
}

const routes = (process.env.VUE_APP_PACKAGE !== 'intuit.portal') ? [] : [
    {
        path: 'units/:pathMatch(.*)?/:noList(no-list)?/:lite(lite)?',
        name: consts.routerNames.units.main,
        meta: {
            list: 'UnitsList',
            mainRouteName: consts.routerNames.units.main,
            showMapInfo: false,
            showMap: true,
            weatherInMap: true,
            unitTracking: true,
            isLimited: true,
            layers: consts.defaultSettingsLayers,
            pageLayout: 'block-position-unit',
            setRoute: defaultSetRoute,
            getUnitDefaultRouteParams: (unitId) => getUnitDefaultRouteParams(unitId)
        },
        props: {
            default: (route) => ({
                unitId: route.params.unitId >= 0 ? +route.params.unitId : undefined
            })
        },
        components: {
            default: () => import('@/views/intuit/portal/UnitsPage.vue'),
        },
        children: [
            {
                path: 'all',
                name: consts.routerNames.units.all.main,
                meta: {
                    mainRouteName: consts.routerNames.units.main,
                    parentRouteName: consts.routerNames.units.main,
                    weatherInMap: true,
                    pageClass: 'only-map',
                    blockingRoutesTransitionFromOutside: true,
                    disableWatchUpdateUnitActive: true,
                    setRoute: {
                        ...defaultSetRoute,
                        unitInfo: (route, router, unitId) => {
                            if (getMainParentRouteName(route.meta?.mainRouteName) !== consts.routerNames.units.main) {
                                if (consts.app.$isDevelopment) console.warn('unitInfo', route);
                                return false;
                            }
                            let routeParams = getUnitDefaultRouteParams(unitId)
                            router.push({
                                name: consts.routerNames.units.all.info,
                                params: {
                                    ...routeParams?.params,
                                },
                                query: {...route.query}
                            })
                        },
                    },
                    layers: {
                        ...consts.defaultSettingsLayers,
                        units: {visible: true, showInList: true, showLayer: true},
                        geoitems: {visible: false, showInList: true, showLayer: true},
                    }
                },
                children: [
                    {
                        path: ':unitId(\\d+)/info',
                        name: consts.routerNames.units.all.info,
                        meta: {
                            mainRouteName: consts.routerNames.units.main,
                            parentRouteName: consts.routerNames.units.all.main,
                            sectionInfoByRoute: true,
                        },
                        props: {
                            sectionInfoByRoute: (route) => ({unitId: +route.params.unitId})
                        },
                        components: {
                            sectionInfoByRoute: () => import('@/components/units/sectionInfo/UnitInfo.vue'),
                        }
                    },
                ]
            },
            {
                path: ':unitId(\\d+)',
                name: consts.routerNames.units.id,
                meta: {
                    mainRouteName: consts.routerNames.units.main,
                    parentRouteName: consts.routerNames.units.main,
                    weatherInMap: true,
                    layers: {
                        ...consts.defaultSettingsLayers,
                        units: {visible: true, showInList: true, showLayer: true},
                        geoitems: {visible: false, showInList: true, showLayer: true},
                    }
                    // pageClass: 'full-size-window'
                },
                children: [
                    {
                        path: ':template(xtrack)',
                        name: consts.routerNames.units.type.xtrack.main,
                        redirect: to => {
                            return {
                                name: consts.routerNames.units.type.xtrack.date,
                                params: {
                                    ...to.params,
                                    date: store.getters.getDateToday,
                                }
                            }
                        },
                        meta: {
                            pageClass: 'unit__xtrack',
                            mainRouteName: consts.routerNames.units.main,
                            parentRouteName: consts.routerNames.units.main,
                            weatherInMap: true,
                            layers: {
                                ...consts.defaultSettingsLayers,
                                units: {visible: true, showInList: true, showLayer: true},
                                geoitems: {visible: false, showInList: true, showLayer: true},
                            }
                        },
                        props: {
                            default: (route) => ({
                                unitId: +route.params.unitId
                            })
                        },
                        components: {
                            default: () => import('@/components/routeView.vue'),
                        },
                        children: [
                            {
                                path: ':date(\\d{4}-\\d{2}-\\d{2})',
                                name: consts.routerNames.units.type.xtrack.date,
                                meta: {
                                    mainRouteName: consts.routerNames.units.main,
                                    parentRouteName: consts.routerNames.units.type.xtrack.main,
                                },
                                props: {
                                    default: (route) => ({
                                        unitId: +route?.params?.unitId,
                                        date: route?.params?.date
                                    }),
                                },
                                components: {
                                    default: () => import('@/components/units/requestsComponents/requestsByDate_base.vue'),
                                },
                                children: [
                                    {
                                        path: 'edit',
                                        name: consts.routerNames.units.type.xtrack.edit,
                                        meta: {
                                            mainRouteName: consts.routerNames.units.main,
                                            parentRouteName: consts.routerNames.units.type.xtrack.date,
                                            blockingRoutesTransitionFromOutside: true,
                                            sectionInfoByRoute: true,
                                        },
                                        props: {
                                            sectionInfoByRoute: (route) => ({
                                                unitId: +route.params.unitId,
                                                time: Date.now(),
                                            })
                                        },
                                        components: {
                                            sectionInfoByRoute: () => import('@/components/units/unit-edit/UnitEdit.vue'),
                                        }
                                    },
                                    {
                                        path: 'info',
                                        name: consts.routerNames.units.type.xtrack.info,
                                        meta: {
                                            mainRouteName: consts.routerNames.units.main,
                                            parentRouteName: consts.routerNames.units.type.xtrack.date,
                                            sectionInfoByRoute: true,
                                        },
                                        props: {
                                            sectionInfoByRoute: (route) => ({unitId: +route.params.unitId})
                                        },
                                        components: {
                                            sectionInfoByRoute: () => import('@/components/units/sectionInfo/UnitInfo.vue'),
                                        }
                                    },
                                    {
                                        path: 'shared-links',
                                        name: consts.routerNames.units.type.xtrack.sharedLinks,
                                        meta: {
                                            mainRouteName: consts.routerNames.units.main,
                                            parentRouteName: consts.routerNames.units.type.xtrack.date,
                                            blockingRoutesTransitionFromOutside: true,
                                            sectionPopupByRoute: {
                                                SectionWrapByRoutePopup: {
                                                    titlePosition: 'center',
                                                }
                                            }
                                        },
                                        props: {
                                            sectionPopupByRoute: (route) => ({
                                                wrapper: 'EditWizard',
                                                class: 'popup-body',
                                                unitId: route.params.unitId ? +route.params.unitId : undefined,
                                            })
                                        },
                                        components: {
                                            sectionPopupByRoute: () => import('@/components/units/shared-links/WizardSharedLinks.vue'),
                                        }
                                    },
                                    {
                                        path: 'fast-geozone',
                                        name: consts.routerNames.units.type.xtrack.fastGeozone,
                                        meta: {
                                            mainRouteName: consts.routerNames.units.main,
                                            parentRouteName: consts.routerNames.units.type.xtrack.date,
                                            blockingRoutesTransitionFromOutside: true,
                                            sectionInfoByRoute: true,
                                            fastGeozone: true,
                                            layers: {
                                                ...consts.defaultSettingsLayers,
                                                units: {visible: true, showInList: true, showLayer: true},
                                                geoitems: {visible: false, showInList: true, showLayer: true},
                                                geoitem_edit: {visible: true, showInList: false, showLayer: true},
                                            }
                                        },
                                        props: {
                                            sectionInfoByRoute: (route) => ({
                                                unitId: +route.params?.unitId,
                                                time: Date.now()
                                            })
                                        },
                                        components: {
                                            sectionInfoByRoute: () => import('@/components/geoitems/geozones/sectionInfo/FastGeozoneEdit.vue'),
                                        }
                                    },
                                    {
                                        path: ':type(parking|driving)?/:trackXid?/:timeFrom(\\d+)?/:timeTo(\\d+)?/:trackColor(track-color)?/:speed(\\d+)?',
                                        name: consts.routerNames.units.type.xtrack.track,
                                        meta: {
                                            unitTracking: false,
                                            mainRouteName: consts.routerNames.units.main,
                                            parentRouteName: consts.routerNames.units.type.xtrack.date,
                                            layers: {
                                                ...consts.defaultSettingsLayers,
                                                units: {visible: false, showInList: true, showLayer: true},
                                                geoitems: {visible: false, showInList: true, showLayer: true},
                                                tracks: {visible: true, showInList: false, showLayer: true},
                                            }
                                        },
                                        props: {},
                                        components: {},
                                        children: []
                                    },
                                    {
                                        path: 'event/:eventXid',
                                        name: consts.routerNames.units.type.xtrack.event,
                                        meta: {
                                            mainRouteName: consts.routerNames.units.type.xtrack.main,
                                            parentRouteName: consts.routerNames.units.type.xtrack.date,
                                            unitTracking: false,
                                            layers: {
                                                ...consts.defaultSettingsLayers,
                                                units: {visible: false, showInList: false, showLayer: false},
                                                geoitems: {visible: false, showInList: true, showLayer: true},
                                                notifications: {visible: true, showInList: false, showLayer: true},
                                            }
                                        },
                                        props: {
                                        },
                                        components: {
                                        },
                                    },
                                ]
                            },
                        ],
                    },
                    {
                        path: ':template(m2m)',
                        name: consts.routerNames.units.type.m2m.main,
                        redirect: to => {
                            return {
                                name: consts.routerNames.units.type.m2m.date,
                                params: {
                                    ...to.params,
                                    date: store.getters.getDateToday,
                                }
                            }
                        },
                        meta: {
                            pageClass: 'unit__xtrack',
                            mainRouteName: consts.routerNames.units.main,
                            parentRouteName: consts.routerNames.units.main,
                            weatherInMap: true,
                            layers: {
                                ...consts.defaultSettingsLayers,
                                units: {visible: true, showInList: true, showLayer: true},
                                geoitems: {visible: false, showInList: true, showLayer: true},
                                unit_zone: {visible: true, showInList: false, showLayer: true},
                            }
                        },
                        props: {
                            default: (route) => ({
                                unitId: +route.params.unitId
                            })
                        },
                        components: {
                            default: () => import('@/components/routeView.vue'),
                        },
                        children: [
                            {
                                path: ':date(\\d{4}-\\d{2}-\\d{2})',
                                name: consts.routerNames.units.type.m2m.date,
                                meta: {
                                    mainRouteName: consts.routerNames.units.main,
                                    parentRouteName: consts.routerNames.units.type.m2m.main,
                                },
                                props: {
                                    default: (route) => ({
                                        unitId: +route?.params?.unitId,
                                        date: route?.params?.date
                                    }),
                                },
                                components: {
                                    default: () => import('@/components/units/requestsComponents/requestsByDate_m2m.vue'),
                                },
                                children: [
                                    {
                                        path: 'edit',
                                        name: consts.routerNames.units.type.m2m.edit,
                                        meta: {
                                            mainRouteName: consts.routerNames.units.main,
                                            parentRouteName: consts.routerNames.units.type.m2m.date,
                                            blockingRoutesTransitionFromOutside: true,
                                            sectionInfoByRoute: true,
                                        },
                                        props: {
                                            sectionInfoByRoute: (route) => ({
                                                unitId: +route.params.unitId,
                                                time: Date.now(),
                                            })
                                        },
                                        components: {
                                            sectionInfoByRoute: () => import('@/components/units/unit-edit/UnitEdit.vue'),
                                        }
                                    },
                                    {
                                        path: 'info',
                                        name: consts.routerNames.units.type.m2m.info,
                                        meta: {
                                            mainRouteName: consts.routerNames.units.main,
                                            parentRouteName: consts.routerNames.units.type.m2m.date,
                                            sectionInfoByRoute: true,
                                        },
                                        props: {
                                            sectionInfoByRoute: (route) => ({unitId: +route.params.unitId})
                                        },
                                        components: {
                                            sectionInfoByRoute: () => import('@/components/units/sectionInfo/UnitInfo.vue'),
                                        }
                                    },
                                    {
                                        path: 'fast-geozone',
                                        name: consts.routerNames.units.type.m2m.fastGeozone,
                                        meta: {
                                            mainRouteName: consts.routerNames.units.main,
                                            parentRouteName: consts.routerNames.units.type.m2m.date,
                                            blockingRoutesTransitionFromOutside: true,
                                            sectionInfoByRoute: true,
                                            fastGeozone: true,
                                            layers: {
                                                ...consts.defaultSettingsLayers,
                                                units: {visible: true, showInList: true, showLayer: true},
                                                geoitems: {visible: false, showInList: true, showLayer: true},
                                                geoitem_edit: {visible: true, showInList: false, showLayer: true},
                                            }
                                        },
                                        props: {
                                            sectionInfoByRoute: (route) => ({
                                                unitId: +route.params?.unitId,
                                                time: Date.now()
                                            })
                                        },
                                        components: {
                                            sectionInfoByRoute: () => import('@/components/geoitems/geozones/sectionInfo/FastGeozoneEdit.vue'),
                                        }
                                    },
                                    {
                                        path: 'track/:type(parking|driving)?/:trackXid?/:timeFrom(\\d+)?/:timeTo(\\d+)?/:trackColor(track-color)?/:speed(\\d+)?',
                                        name: consts.routerNames.units.type.m2m.track,
                                        meta: {
                                            unitTracking: false,
                                            mainRouteName: consts.routerNames.units.main,
                                            parentRouteName: consts.routerNames.units.type.m2m.date,
                                            layers: {
                                                ...consts.defaultSettingsLayers,
                                                units: {visible: false, showInList: true, showLayer: true},
                                                geoitems: {visible: false, showInList: true, showLayer: true},
                                                tracks: {visible: true, showInList: false, showLayer: true},
                                            }
                                        },
                                        props: {},
                                        components: {},
                                        children: []
                                    },
                                    {
                                        path: 'event/:eventXid',
                                        name: consts.routerNames.units.type.m2m.event,
                                        meta: {
                                            mainRouteName: consts.routerNames.units.type.m2m.main,
                                            parentRouteName: consts.routerNames.units.type.m2m.date,
                                            unitTracking: false,
                                            layers: {
                                                ...consts.defaultSettingsLayers,
                                                units: {visible: false, showInList: false, showLayer: false},
                                                geoitems: {visible: false, showInList: true, showLayer: true},
                                                notifications: {visible: true, showInList: false, showLayer: true},
                                            }
                                        },
                                        props: {
                                        },
                                        components: {
                                        },
                                    },
                                    {
                                        path: 'shared-links',
                                        name: consts.routerNames.units.type.m2m.sharedLinks,
                                        meta: {
                                            mainRouteName: consts.routerNames.units.main,
                                            parentRouteName: consts.routerNames.units.type.m2m.date,
                                            blockingRoutesTransitionFromOutside: true,
                                            sectionPopupByRoute: {
                                                SectionWrapByRoutePopup: {
                                                    titlePosition: 'center',
                                                }
                                            }
                                        },
                                        props: {
                                            sectionPopupByRoute: (route) => ({
                                                wrapper: 'EditWizard',
                                                class: 'popup-body',
                                                unitId: route.params.unitId ? +route.params.unitId : undefined,
                                            })
                                        },
                                        components: {
                                            sectionPopupByRoute: () => import('@/components/units/shared-links/WizardSharedLinks.vue'),
                                        }
                                    },
                                ]
                            },
                        ],
                    },
                    {
                        path: ':template(xvision)',
                        name: consts.routerNames.units.type.xvision.main,
                        redirect: to => {
                            return {
                                name: consts.routerNames.units.type.xvision.date,
                                params: {
                                    ...to.params,
                                    date: store.getters.getDateToday,
                                }
                            }
                        },
                        meta: {
                            mainRouteName: consts.routerNames.units.main,
                            parentRouteName: consts.routerNames.units.id,
                            pageClass: 'unit__xvision',
                            showMapInfo: false,
                            weatherInMap: true,
                            isVideo: true,
                            showTimeCapsuleButton: true,
                            layers: {
                                ...consts.defaultSettingsLayers,
                                units: {visible: true, showInList: true, showLayer: true},
                                geoitems: {visible: false, showInList: true, showLayer: true},
                            }
                        },
                        props: {
                        },
                        components: {
                            default: () => import('@/components/routeView.vue'),
                        },
                        children: [
                            {
                                path: ':date(\\d{4}-\\d{2}-\\d{2})',
                                name: consts.routerNames.units.type.xvision.date,
                                meta: {
                                    mainRouteName: consts.routerNames.units.main,
                                    parentRouteName: consts.routerNames.units.type.xvision.main,
                                },
                                props: {
                                    default: (route) => ({
                                        unitId: +route?.params?.unitId,
                                        date: route?.params?.date
                                    }),
                                },
                                components: {
                                    default: () => import('@/components/units/requestsComponents/requestsByDate_base.vue'),
                                },
                                children: [
                                    {
                                        path: 'edit',
                                        name: consts.routerNames.units.type.xvision.edit,
                                        meta: {
                                            mainRouteName: consts.routerNames.units.main,
                                            parentRouteName: consts.routerNames.units.type.xvision.date,
                                            blockingRoutesTransitionFromOutside: true,
                                            sectionInfoByRoute: true,
                                        },
                                        props: {
                                            sectionInfoByRoute: (route) => ({
                                                unitId: +route.params.unitId,
                                                time: Date.now(),
                                            })
                                        },
                                        components: {
                                            sectionInfoByRoute: () => import('@/components/units/unit-edit/UnitEdit.vue'),
                                        }
                                    },
                                    {
                                        path: 'info',
                                        name: consts.routerNames.units.type.xvision.info,
                                        meta: {
                                            mainRouteName: consts.routerNames.units.main,
                                            parentRouteName: consts.routerNames.units.type.xvision.date,
                                            sectionInfoByRoute: true,
                                        },
                                        props: {
                                            sectionInfoByRoute: (route) => ({unitId: +route.params.unitId})
                                        },
                                        components: {
                                            sectionInfoByRoute: () => import('@/components/units/sectionInfo/UnitInfo.vue'),
                                        }
                                    },
                                    {
                                        path: 'fast-geozone',
                                        name: consts.routerNames.units.type.xvision.fastGeozone,
                                        meta: {
                                            mainRouteName: consts.routerNames.units.main,
                                            parentRouteName: consts.routerNames.units.type.xvision.date,
                                            blockingRoutesTransitionFromOutside: true,
                                            sectionInfoByRoute: true,
                                            fastGeozone: true,
                                        },
                                        props: {
                                            sectionInfoByRoute: (route) => ({
                                                unitId: +route.params?.unitId,
                                                time: Date.now()
                                            })
                                        },
                                        components: {
                                            sectionInfoByRoute: () => import('@/components/geoitems/geozones/sectionInfo/FastGeozoneEdit.vue'),
                                        }
                                    },
                                    {
                                        path: 'track/:type(parking|driving)?/:trackXid?/:timeFrom(\\d+)?/:timeTo(\\d+)?/:trackColor(track-color)?/:speed(\\d+)?',
                                        name: consts.routerNames.units.type.xvision.track,
                                        meta: {
                                            unitTracking: false,
                                            mainRouteName: consts.routerNames.units.main,
                                            parentRouteName: consts.routerNames.units.type.xvision.date,
                                            layers: {
                                                ...consts.defaultSettingsLayers,
                                                units: {visible: false, showInList: true, showLayer: true},
                                                geoitems: {visible: false, showInList: true, showLayer: true},
                                                tracks: {visible: true, showInList: false, showLayer: true},
                                            }
                                        },
                                        props: {},
                                        components: {},
                                        children: []
                                    },
                                    {
                                        path: 'event/:eventXid',
                                        name: consts.routerNames.units.type.xvision.event,
                                        meta: {
                                            mainRouteName: consts.routerNames.units.type.xvision.main,
                                            parentRouteName: consts.routerNames.units.type.xvision.date,
                                            unitTracking: false,
                                            layers: {
                                                ...consts.defaultSettingsLayers,
                                                units: {visible: false, showInList: false, showLayer: false},
                                                geoitems: {visible: false, showInList: true, showLayer: true},
                                                notifications: {visible: true, showInList: false, showLayer: true},
                                            }
                                        },
                                        props: {
                                        },
                                        components: {
                                        },
                                    },
                                    {
                                        path: 'live-video',
                                        name: consts.routerNames.units.type.xvision.liveVideo,
                                        meta: {
                                            mainRouteName: consts.routerNames.units.main,
                                            parentRouteName: consts.routerNames.units.type.xvision.date,
                                            blockingRoutesTransitionFromOutside: true,
                                            pageClass: 'unit__xvision unit__xvision-video playback-hide',
                                            showMapInfo: false
                                        },
                                        props: {
                                            LiveVideoComponent: (route) => ({unitId: +route.params.unitId})
                                        },
                                        components: {
                                            LiveVideoComponent: () => import('@/components/video/control/live-video/LiveVideo.vue'),
                                        },
                                    },
                                    {
                                        path: 'video-event/:eventXid',
                                        name: consts.routerNames.units.type.xvision.videoEvent,
                                        meta: {
                                            mainRouteName: consts.routerNames.units.main,
                                            parentRouteName: consts.routerNames.units.type.xvision.date,
                                            pageClass: 'unit__xvision unit__xvision-video',
                                            showMapInfo: false,
                                        },
                                        props: {
                                            VideoEventComponent: (route) => ({eventXid: route.params.eventXid})
                                        },
                                        components: {
                                            VideoEventComponent: () => import('@/components/video/control/video-event/VideoEvent.vue')
                                        },
                                    },
                                    {
                                        path: 'snapshots/:eventXid',
                                        name: consts.routerNames.units.type.xvision.snapshots,
                                        meta: {
                                            mainRouteName: consts.routerNames.units.main,
                                            parentRouteName: consts.routerNames.units.type.xvision.date,
                                            pageClass: 'unit__xvision unit__xvision-video',
                                            showMapInfo: false,
                                        },
                                        props: {
                                            VideoEventComponent: (route) => ({
                                                unitId: +route.params.unitId,
                                                eventXid: route.params.eventXid
                                            })
                                        },
                                        components: {
                                            VideoEventComponent: () => import('@/components/units/info/UnitInfo_screenWall.vue'),
                                        },
                                    },
                                    {
                                        path: 'video-request/:eventXid',
                                        name: consts.routerNames.units.type.xvision.videoRequest,
                                        meta: {
                                            mainRouteName: consts.routerNames.units.main,
                                            parentRouteName: consts.routerNames.units.type.xvision.date,
                                            pageClass: 'unit__xvision unit__xvision-video playback-hide',
                                            isVideo: true,
                                            showMapInfo: false
                                        },
                                        props: {
                                            VideoEventComponent: (route) => ({eventXid: route.params.eventXid})
                                        },
                                        components: {
                                            VideoEventComponent: () => import('@/components/video/control/video-request/VideoRequest.vue')
                                        },
                                    },
                                    {
                                        path: 'shared-links',
                                        name: consts.routerNames.units.type.xvision.sharedLinks,
                                        meta: {
                                            mainRouteName: consts.routerNames.units.main,
                                            parentRouteName: consts.routerNames.units.type.xvision.date,
                                            blockingRoutesTransitionFromOutside: true,
                                            sectionPopupByRoute: {
                                                SectionWrapByRoutePopup: {
                                                    titlePosition: 'center',
                                                }
                                            }
                                        },
                                        props: {
                                            sectionPopupByRoute: (route) => ({
                                                wrapper: 'EditWizard',
                                                class: 'popup-body',
                                                unitId: route.params.unitId ? +route.params.unitId : undefined,
                                            })
                                        },
                                        components: {
                                            sectionPopupByRoute: () => import('@/components/units/shared-links/WizardSharedLinks.vue'),
                                        }
                                    },
                                    // {
                                    //     path: 'smart-search/:mode(time|geozone)?/:from(\\d+)?/:to(\\d+)?',
                                    //     name: consts.routerNames.units.type.xvision.smartSearch,
                                    //     meta: {
                                    //         unitTracking: false,
                                    //         mainRouteName: consts.routerNames.units.main,
                                    //         parentRouteName: consts.routerNames.units.type.xvision,
                                    //     },
                                    //     props: {
                                    //     },
                                    //     components: {
                                    //     },
                                    //     children: [
                                    //         {
                                    //             path: 'video-request/:eventXid',
                                    //             name: consts.routerNames.units.type.xvision.smartSearch + '.video-request',
                                    //             meta: {
                                    //                 mainRouteName: consts.routerNames.units.main,
                                    //                 parentRouteName: consts.routerNames.units.type.xvision.smartSearch,
                                    //                 pageClass: 'unit__xvision unit__xvision-video playback-hide',
                                    //                 isVideo: true,
                                    //                 showMapInfo: false
                                    //             },
                                    //             props: {
                                    //                 default: (route) => ({eventXid: route.params.eventXid})
                                    //             },
                                    //             components: {
                                    //                 default: () => import('@/components/video/control/video-request/VideoRequest.vue')
                                    //             },
                                    //         },
                                    //     ]
                                    // },
                                ]
                            },
                            {
                                path: 'time-capsule/:date(\\d{4}-\\d{2}-\\d{2})',
                                name: consts.routerNames.units.type.xvision.timeCapsule.date,
                                meta: {
                                    mainRouteName: consts.routerNames.units.type.xvision.main,
                                    parentRouteName: consts.routerNames.units.type.xvision.timeCapsule.main,
                                    pageClass: 'unit__time-capsule',
                                    layers: {
                                        ...consts.defaultSettingsLayers,
                                        unit_mouse_move: {visible: true, showInList: false, showLayer: true},
                                    },
                                },
                                props: {
                                    default: (route) => {
                                        let params = replaceParams(route)
                                        return {
                                            unitId: params?.unitId,
                                            date: route?.params?.date
                                        }
                                    },
                                },
                                components: {
                                    default: () => import('@/components/units/requestsComponents/requestsByDate_timeCapsule_xvision.vue'),
                                },
                                children: [
                                    {
                                        path: ':eventXid',
                                        name: consts.routerNames.units.type.xvision.timeCapsule.video,
                                        meta:{
                                            mainRouteName: consts.routerNames.units.type.xvision.main,
                                            parentRouteName: consts.routerNames.units.type.xvision.timeCapsule.date,
                                            sectionPopupByRoute: true
                                        },
                                        props: {
                                            sectionPopupByRoute: (route) => {
                                                let params = replaceParams(route)
                                                return {eventXid: params.eventXid, unitId: +params?.unitId}
                                            }
                                        },
                                        components: {
                                            // sectionPopupByRoute: () => import('@/components/video_requests/sectionInfo/VideoRequestView.vue')
                                            sectionPopupByRoute: () => import('@/components/units/screen-wall/time-capsule/TimeCapsuleModalInfo.vue')
                                        }
                                    }
                                ]
                            }
                        ],
                    },
                    {
                        path: ':template(xcool)',
                        name: consts.routerNames.units.type.xcool.main,
                        redirect: to => {
                            return {
                                name: consts.routerNames.units.type.xcool.date,
                                params: {
                                    ...to.params,
                                    date: store.getters.getDateToday,
                                }
                            }
                        },
                        meta: {
                            mainRouteName: consts.routerNames.units.main,
                            parentRouteName: consts.routerNames.units.main,
                            pageClass: 'unit__xcool',
                            layers: {
                                ...consts.defaultSettingsLayers,
                                units: {visible: true, showInList: true, showLayer: true},
                                geoitems: {visible: false, showInList: true, showLayer: true},
                            },
                            componentsSettings: {
                                UnitInfo__hardware: {
                                    class: 'hide-car-info'
                                },
                                UnitInfo__address: {
                                    class: 'hide-car-info'
                                }
                            },
                            weatherInMap: true,
                        },
                        props: {
                            default: (route) => ({
                                unitId: +route.params.unitId,
                            })
                        },
                        components: {
                            default: () => import('@/components/routeView.vue'),
                        },
                        children: [
                            {
                                path: ':date(\\d{4}-\\d{2}-\\d{2})',
                                name: consts.routerNames.units.type.xcool.date,
                                meta: {
                                    mainRouteName: consts.routerNames.units.main,
                                    parentRouteName: consts.routerNames.units.type.xcool.main,
                                },
                                props: {
                                    default: (route) => ({
                                        unitId: +route?.params?.unitId,
                                        date: route?.params?.date
                                    }),
                                },
                                components: {
                                    default: () => import('@/components/units/requestsComponents/requestsByDate_xcool.vue'),
                                },
                                children: [
                                    {
                                        path: 'edit',
                                        name: consts.routerNames.units.type.xcool.edit,
                                        meta: {
                                            mainRouteName: consts.routerNames.units.main,
                                            parentRouteName: consts.routerNames.units.type.xcool.date,
                                            blockingRoutesTransitionFromOutside: true,
                                            sectionInfoByRoute: true,
                                        },
                                        props: {
                                            sectionInfoByRoute: (route) => ({
                                                unitId: +route.params.unitId,
                                                time: Date.now(),
                                            })
                                        },
                                        components: {
                                            sectionInfoByRoute: () => import('@/components/units/unit-edit/UnitEdit.vue'),
                                        }
                                    },
                                    {
                                        path: 'info',
                                        name: consts.routerNames.units.type.xcool.info,
                                        meta: {
                                            mainRouteName: consts.routerNames.units.main,
                                            parentRouteName: consts.routerNames.units.type.xcool.date,
                                            sectionInfoByRoute: true,
                                        },
                                        props: {
                                            sectionInfoByRoute: (route) => ({unitId: +route.params.unitId})
                                        },
                                        components: {
                                            sectionInfoByRoute: () => import('@/components/units/sectionInfo/UnitInfo.vue'),
                                        }
                                    },
                                    {
                                        path: 'event/:eventXid',
                                        name: consts.routerNames.units.type.xcool.event,
                                        meta: {
                                            mainRouteName: consts.routerNames.units.type.xcool.main,
                                            parentRouteName: consts.routerNames.units.type.xcool.date,
                                            unitTracking: false,
                                            layers: {
                                                ...consts.defaultSettingsLayers,
                                                units: {visible: false, showInList: false, showLayer: false},
                                                geoitems: {visible: false, showInList: true, showLayer: true},
                                                notifications: {visible: true, showInList: false, showLayer: true},
                                            }
                                        },
                                        props: {
                                        },
                                        components: {
                                        },
                                    },
                                    {
                                        path: 'fast-geozone',
                                        name: consts.routerNames.units.type.xcool.fastGeozone,
                                        meta: {
                                            mainRouteName: consts.routerNames.units.main,
                                            parentRouteName: consts.routerNames.units.type.xcool.date,
                                            blockingRoutesTransitionFromOutside: true,
                                            sectionInfoByRoute: true,
                                            fastGeozone: true,
                                        },
                                        props: {
                                            sectionInfoByRoute: (route) => ({
                                                unitId: +route.params?.unitId,
                                                time: Date.now()
                                            })
                                        },
                                        components: {
                                            sectionInfoByRoute: () => import('@/components/geoitems/geozones/sectionInfo/FastGeozoneEdit.vue'),
                                        }
                                    },
                                    {
                                        path: 'reefer',
                                        name: consts.routerNames.units.type.xcool.reefer,
                                        meta: {
                                            mainRouteName: consts.routerNames.units.main,
                                            parentRouteName: consts.routerNames.units.type.xcool.date,
                                            pageClass: 'reefer-active map-bottom-right',
                                        },
                                        props: {
                                            UnitControl_reefer: (route) => ({
                                                unitId: +route.params?.unitId,
                                            })
                                        },
                                        components: {
                                            UnitControl_reefer: () => import('@/components/units/control/UnitControl_reefer.vue'),
                                        }
                                    },
                                    {
                                        path: ':type(parking|driving)?/:trackXid?/:timeFrom(\\d+)?/:timeTo(\\d+)?/:trackColor(track-color)?/:speed(\\d+)?',
                                        name: consts.routerNames.units.type.xcool.track,
                                        meta: {
                                            unitTracking: false,
                                            mainRouteName: consts.routerNames.units.main,
                                            parentRouteName: consts.routerNames.units.type.xcool.date,
                                            layers: {
                                                ...consts.defaultSettingsLayers,
                                                units: {visible: false, showInList: true, showLayer: true},
                                                geoitems: {visible: false, showInList: true, showLayer: true},
                                                tracks: {visible: true, showInList: false, showLayer: true},
                                            }
                                        },
                                        props: {},
                                        components: {},
                                        children: []
                                    },
                                    {
                                        path: 'shared-links',
                                        name: consts.routerNames.units.type.xcool.sharedLinks,
                                        meta: {
                                            mainRouteName: consts.routerNames.units.main,
                                            parentRouteName: consts.routerNames.units.type.xcool.date,
                                            blockingRoutesTransitionFromOutside: true,
                                            sectionPopupByRoute: {
                                                SectionWrapByRoutePopup: {
                                                    titlePosition: 'center',
                                                }
                                            }
                                        },
                                        props: {
                                            sectionPopupByRoute: (route) => ({
                                                wrapper: 'EditWizard',
                                                class: 'popup-body',
                                                unitId: route.params.unitId ? +route.params.unitId : undefined,
                                            })
                                        },
                                        components: {
                                            sectionPopupByRoute: () => import('@/components/units/shared-links/WizardSharedLinks.vue'),
                                        }
                                    },
                                ]
                            },
                        ],
                    },
                    {
                        path: ':template(xpower)',
                        name: consts.routerNames.units.type.xpower.main,
                        redirect: to => {
                            return {
                                name: consts.routerNames.units.type.xpower.date,
                                params: {
                                    ...to.params,
                                    date: store.getters.getDateToday,
                                }
                            }
                        },
                        meta: {
                            mainRouteName: consts.routerNames.units.main,
                            parentRouteName: consts.routerNames.units.main,
                            pageClass: 'unit-generator-page unit-generator-main-page',
                            // weatherInMap: true,
                            layers: {
                                ...consts.defaultSettingsLayers,
                                units: {visible: true, showInList: true, showLayer: true},
                                geoitems: {visible: false, showInList: true, showLayer: true},
                            }
                        },
                        props: {
                        },
                        components: {
                            default: () => import('@/components/routeView.vue'),
                        },
                        children: [
                            {
                                path: ':date(\\d{4}-\\d{2}-\\d{2})',
                                name: consts.routerNames.units.type.xpower.date,
                                meta: {
                                    mainRouteName: consts.routerNames.units.main,
                                    parentRouteName: consts.routerNames.units.type.xpower.main,
                                },
                                props: {
                                    default: (route) => ({
                                        unitId: +route?.params?.unitId,
                                        date: route?.params?.date,
                                        sensors: ['last_message', 'phaseAB', 'phaseBC', 'phaseCA', 'fuel_level'],
                                    }),
                                },
                                components: {
                                    default: () => import('@/components/units/requestsComponents/requestsByDate_xpower.vue'),
                                },
                                children: [
                                    {
                                        path: 'edit',
                                        name: consts.routerNames.units.type.xpower.edit,
                                        meta: {
                                            mainRouteName: consts.routerNames.units.main,
                                            parentRouteName: consts.routerNames.units.type.xpower.date,
                                            blockingRoutesTransitionFromOutside: true,
                                            sectionInfoByRoute: true,
                                        },
                                        props: {
                                            sectionInfoByRoute: (route) => ({
                                                unitId: +route.params.unitId,
                                                time: Date.now(),
                                            })
                                        },
                                        components: {
                                            sectionInfoByRoute: () => import('@/components/units/unit-edit/UnitEdit.vue'),
                                        }
                                    },
                                    {
                                        path: 'info',
                                        name: consts.routerNames.units.type.xpower.info,
                                        meta: {
                                            mainRouteName: consts.routerNames.units.main,
                                            parentRouteName: consts.routerNames.units.type.xpower.date,
                                            sectionInfoByRoute: true,
                                        },
                                        props: {
                                            sectionInfoByRoute: (route) => ({unitId: +route.params.unitId})
                                        },
                                        components: {
                                            sectionInfoByRoute: () => import('@/components/units/sectionInfo/UnitInfo.vue'),
                                        }
                                    },
                                    {
                                        path: 'event/:eventXid',
                                        name: consts.routerNames.units.type.xpower.event,
                                        meta: {
                                            mainRouteName: consts.routerNames.units.type.xpower.main,
                                            parentRouteName: consts.routerNames.units.type.xpower.date,
                                            unitTracking: false,
                                            layers: {
                                                ...consts.defaultSettingsLayers,
                                                units: {visible: false, showInList: false, showLayer: false},
                                                geoitems: {visible: false, showInList: true, showLayer: true},
                                                notifications: {visible: true, showInList: false, showLayer: true},
                                            }
                                        },
                                        props: {
                                        },
                                        components: {
                                        },
                                    },
                                    {
                                        path: 'fast-geozone',
                                        name: consts.routerNames.units.type.xpower.fastGeozone,
                                        meta: {
                                            mainRouteName: consts.routerNames.units.main,
                                            parentRouteName: consts.routerNames.units.type.xpower.date,
                                            blockingRoutesTransitionFromOutside: true,
                                            sectionInfoByRoute: true,
                                            fastGeozone: true,
                                        },
                                        props: {
                                            sectionInfoByRoute: (route) => ({
                                                unitId: +route.params?.unitId,
                                                time: Date.now()
                                            })
                                        },
                                        components: {
                                            sectionInfoByRoute: () => import('@/components/geoitems/geozones/sectionInfo/FastGeozoneEdit.vue'),
                                        }
                                    },
                                    {
                                        path: ':type(parking|driving)?/:trackXid?/:timeFrom(\\d+)?/:timeTo(\\d+)?/:trackColor(track-color)?/:speed(\\d+)?',
                                        name: consts.routerNames.units.type.xpower.track,
                                        meta: {
                                            unitTracking: false,
                                            mainRouteName: consts.routerNames.units.main,
                                            parentRouteName: consts.routerNames.units.type.xpower.date,
                                            layers: {
                                                ...consts.defaultSettingsLayers,
                                                units: {visible: false, showInList: true, showLayer: true},
                                                geoitems: {visible: false, showInList: true, showLayer: true},
                                                tracks: {visible: true, showInList: false, showLayer: true},
                                            }
                                        },
                                        props: {},
                                        components: {},
                                        children: []
                                    },
                                    {
                                        path: 'control',
                                        name: consts.routerNames.units.type.xpower.control,
                                        meta: {
                                            mainRouteName: consts.routerNames.units.main,
                                            parentRouteName: consts.routerNames.units.type.xpower.date,
                                            pageClass: 'unit-generator-page unit-generator-main-page',
                                        },
                                        props: {
                                            main: (route) => ({
                                                unitId: +route.params.unitId,
                                            })
                                        },
                                        components: {
                                            main: () => import('@/components/units/info/generator/UnitInfo_generator_main.vue'),
                                        },
                                    },
                                    {
                                        path: 'analytics',
                                        name: consts.routerNames.units.type.xpower.analytics,
                                        meta: {
                                            mainRouteName: consts.routerNames.units.main,
                                            parentRouteName: consts.routerNames.units.type.xpower.date,
                                            pageClass: 'unit-generator-page unit-generator-analytics-page',
                                        },
                                        props: {
                                            main: (route) => ({
                                                unitId: +route.params.unitId,
                                                grafanaSensors: ['phaseAB', 'phaseBC', 'phaseCA', 'fuel_lvl'],
                                            })
                                        },
                                        components: {
                                            main: () => import('@/components/units/info/generator/UnitInfo_generator_analytics.vue'),
                                        },
                                    },
                                    {
                                        path: 'history',
                                        name: consts.routerNames.units.type.xpower.history,
                                        meta: {
                                            mainRouteName: consts.routerNames.units.main,
                                            parentRouteName: consts.routerNames.units.type.xpower.date,
                                            pageClass: 'unit-generator-page unit-generator-history-page',
                                        },
                                        props: {
                                            main: (route) => ({
                                                unitId: +route.params.unitId,
                                            })
                                        },
                                        components: {
                                            main: () => import('@/components/units/info/generator/UnitInfo_generator_history.vue'),
                                        },
                                    },
                                    {
                                        path: 'shared-links',
                                        name: consts.routerNames.units.type.xpower.sharedLinks,
                                        meta: {
                                            mainRouteName: consts.routerNames.units.main,
                                            parentRouteName: consts.routerNames.units.type.xpower.date,
                                            blockingRoutesTransitionFromOutside: true,
                                            sectionPopupByRoute: {
                                                SectionWrapByRoutePopup: {
                                                    titlePosition: 'center',
                                                }
                                            }
                                        },
                                        props: {
                                            sectionPopupByRoute: (route) => ({
                                                wrapper: 'EditWizard',
                                                class: 'popup-body',
                                                unitId: route.params.unitId ? +route.params.unitId : undefined,
                                            })
                                        },
                                        components: {
                                            sectionPopupByRoute: () => import('@/components/units/shared-links/WizardSharedLinks.vue'),
                                        }
                                    },
                                ]
                            },
                        ],
                    },
                    {
                        path: ':template(xgrafana)',
                        name: consts.routerNames.units.type.xgrafana.main,
                        redirect: to => {
                            return {
                                name: consts.routerNames.units.type.xgrafana.date,
                                params: {
                                    ...to.params,
                                    date: store.getters.getDateToday,
                                }
                            }
                        },
                        meta: {
                            mainRouteName: consts.routerNames.units.main,
                            parentRouteName: consts.routerNames.units.main,
                            pageClass: 'unit-graph unit-graph__xgrafana-map',
                            weatherInMap: true,
                            mapType: 'Google-Hybrid',
                            layers: {
                                ...consts.defaultSettingsLayers,
                                units: {visible: true, showInList: true, showLayer: true},
                                track_by_points: {visible: true, showInList: true, showLayer: true},
                            },
                            componentsSettings: {
                                UnitInfo__sensors: {
                                    sensors: [
                                        'last_message',
                                        'speed',
                                        'status',
                                        'main_power',
                                        'battery',
                                        'inputs',
                                        'outputs',
                                    ],
                                }
                            },
                        },
                        props: {
                        },
                        components: {
                            default: () => import('@/components/routeView.vue'),
                        },
                        children: [
                            {
                                path: ':date(\\d{4}-\\d{2}-\\d{2})',
                                name: consts.routerNames.units.type.xgrafana.date,
                                meta: {
                                    mainRouteName: consts.routerNames.units.main,
                                    parentRouteName: consts.routerNames.units.type.xgrafana.main,
                                },
                                props: {
                                    default: (route) => ({
                                        unitId: +route?.params?.unitId,
                                        date: route?.params?.date
                                    }),
                                },
                                components: {
                                    default: () => import('@/components/units/requestsComponents/requestsByDate_xgrafana.vue'),
                                },
                                children: [
                                    {
                                        path: 'edit',
                                        name: consts.routerNames.units.type.xgrafana.edit,
                                        meta: {
                                            mainRouteName: consts.routerNames.units.main,
                                            parentRouteName: consts.routerNames.units.type.xgrafana.date,
                                            blockingRoutesTransitionFromOutside: true,
                                            sectionInfoByRoute: true,
                                        },
                                        props: {
                                            sectionInfoByRoute: (route) => ({
                                                unitId: +route.params.unitId,
                                                time: Date.now(),
                                            })
                                        },
                                        components: {
                                            sectionInfoByRoute: () => import('@/components/units/unit-edit/UnitEdit.vue'),
                                        }
                                    },
                                    {
                                        path: 'info',
                                        name: consts.routerNames.units.type.xgrafana.info,
                                        meta: {
                                            mainRouteName: consts.routerNames.units.main,
                                            parentRouteName: consts.routerNames.units.type.xgrafana.date,
                                            sectionInfoByRoute: true,
                                        },
                                        props: {
                                            sectionInfoByRoute: (route) => ({unitId: +route.params.unitId})
                                        },
                                        components: {
                                            sectionInfoByRoute: () => import('@/components/units/sectionInfo/UnitInfo.vue'),
                                        }
                                    },
                                    {
                                        path: 'event/:eventXid',
                                        name: consts.routerNames.units.type.xgrafana.event,
                                        meta: {
                                            mainRouteName: consts.routerNames.units.type.xgrafana.main,
                                            parentRouteName: consts.routerNames.units.type.xgrafana.date,
                                            unitTracking: false,
                                            layers: {
                                                ...consts.defaultSettingsLayers,
                                                units: {visible: false, showInList: false, showLayer: false},
                                                geoitems: {visible: false, showInList: true, showLayer: true},
                                                notifications: {visible: true, showInList: false, showLayer: true},
                                            }
                                        },
                                        props: {
                                        },
                                        components: {
                                        },
                                    },
                                    {
                                        path: 'fast-geozone',
                                        name: consts.routerNames.units.type.xgrafana.fastGeozone,
                                        meta: {
                                            mainRouteName: consts.routerNames.units.main,
                                            parentRouteName: consts.routerNames.units.type.xgrafana.date,
                                            blockingRoutesTransitionFromOutside: true,
                                            sectionInfoByRoute: true,
                                            fastGeozone: true,
                                        },
                                        props: {
                                            sectionInfoByRoute: (route) => ({
                                                unitId: +route.params?.unitId,
                                                time: Date.now()
                                            })
                                        },
                                        components: {
                                            sectionInfoByRoute: () => import('@/components/geoitems/geozones/sectionInfo/FastGeozoneEdit.vue'),
                                        }
                                    },
                                    {
                                        path: ':type(parking|driving)?/:trackXid?/:timeFrom(\\d+)?/:timeTo(\\d+)?/:trackColor(track-color)?/:speed(\\d+)?',
                                        name: consts.routerNames.units.type.xgrafana.track,
                                        meta: {
                                            unitTracking: false,
                                            mainRouteName: consts.routerNames.units.main,
                                            parentRouteName: consts.routerNames.units.type.xgrafana.date,
                                            layers: {
                                                ...consts.defaultSettingsLayers,
                                                units: {visible: false, showInList: true, showLayer: true},
                                                geoitems: {visible: false, showInList: true, showLayer: true},
                                                tracks: {visible: true, showInList: false, showLayer: true},
                                            }
                                        },
                                        props: {},
                                        components: {},
                                        children: []
                                    },
                                    {
                                        path: 'sensors',
                                        name: consts.routerNames.units.type.xgrafana.sensors,
                                        meta: {
                                            mainRouteName: consts.routerNames.units.main,
                                            parentRouteName: consts.routerNames.units.type.xgrafana.date,
                                            pageClass: 'unit-graph map-bottom-right',
                                            weatherInMap: false,
                                        },
                                    },
                                    {
                                        path: 'shared-links',
                                        name: consts.routerNames.units.type.xgrafana.sharedLinks,
                                        meta: {
                                            mainRouteName: consts.routerNames.units.main,
                                            parentRouteName: consts.routerNames.units.type.xgrafana.date,
                                            blockingRoutesTransitionFromOutside: true,
                                            sectionPopupByRoute: {
                                                SectionWrapByRoutePopup: {
                                                    titlePosition: 'center',
                                                }
                                            }
                                        },
                                        props: {
                                            sectionPopupByRoute: (route) => ({
                                                wrapper: 'EditWizard',
                                                class: 'popup-body',
                                                unitId: route.params.unitId ? +route.params.unitId : undefined,
                                            })
                                        },
                                        components: {
                                            sectionPopupByRoute: () => import('@/components/units/shared-links/WizardSharedLinks.vue'),
                                        }
                                    },
                                ]
                            },
                        ],
                    },
                    {
                        path: ':template(xlink)',
                        name: consts.routerNames.units.type.xlink.main,
                        redirect: to => {
                            return {
                                name: consts.routerNames.units.type.xlink.date,
                                params: {
                                    ...to.params,
                                    date: store.getters.getDateToday,
                                }
                            }
                        },
                        meta: {
                            mainRouteName: consts.routerNames.units.main,
                            parentRouteName: consts.routerNames.units.main,
                            pageClass: 'section-unit-xlink',
                            weatherInMap: false,
                            showMapInfo: true,
                            layers: {
                                ...consts.defaultSettingsLayers,
                                units: {visible: true, showInList: true, showLayer: true},
                                geoitems: {visible: false, showInList: true, showLayer: true},
                            },
                            componentsSettings: {
                                UnitInfo__sensors: {
                                    class: 'sensors-xlink'
                                }
                            },
                        },
                        props: {
                        },
                        components: {
                            default: () => import('@/components/routeView.vue'),
                        },
                        children: [
                            {
                                path: ':date(\\d{4}-\\d{2}-\\d{2})',
                                name: consts.routerNames.units.type.xlink.date,
                                meta: {
                                    mainRouteName: consts.routerNames.units.main,
                                    parentRouteName: consts.routerNames.units.type.xlink.main,
                                },
                                props: {
                                    default: (route) => ({
                                        unitId: +route?.params?.unitId,
                                        date: route?.params?.date,
                                        sensors: ['name', 'mac', 'connection_type', 'last_message', 'battery_voltage', 'temperature', 'humidity'],
                                    }),
                                },
                                components: {
                                    default: () => import('@/components/units/requestsComponents/requestsByDate_xlink.vue'),
                                },
                                children: [
                                    {
                                        path: 'event/:eventXid',
                                        name: consts.routerNames.units.type.xlink.event,
                                        meta: {
                                            mainRouteName: consts.routerNames.units.type.xlink.main,
                                            parentRouteName: consts.routerNames.units.type.xlink.date,
                                            unitTracking: false,
                                            layers: {
                                                ...consts.defaultSettingsLayers,
                                                units: {visible: false, showInList: false, showLayer: false},
                                                geoitems: {visible: false, showInList: true, showLayer: true},
                                                notifications: {visible: true, showInList: false, showLayer: true},
                                            }
                                        },
                                        props: {
                                        },
                                        components: {
                                        },
                                    },
                                    {
                                        path: 'edit',
                                        name: consts.routerNames.units.type.xlink.edit,
                                        meta: {
                                            mainRouteName: consts.routerNames.units.main,
                                            parentRouteName: consts.routerNames.units.type.xlink.date,
                                            blockingRoutesTransitionFromOutside: true,
                                            sectionInfoByRoute: true,
                                        },
                                        props: {
                                            sectionInfoByRoute: (route) => ({
                                                unitId: +route.params.unitId,
                                                time: Date.now(),
                                            })
                                        },
                                        components: {
                                            sectionInfoByRoute: () => import('@/components/units/unit-edit/UnitEdit.vue'),
                                        }
                                    },
                                    {
                                        path: 'fast-geozone',
                                        name: consts.routerNames.units.type.xlink.fastGeozone,
                                        meta: {
                                            mainRouteName: consts.routerNames.units.main,
                                            parentRouteName: consts.routerNames.units.type.xlink.date,
                                            blockingRoutesTransitionFromOutside: true,
                                            sectionInfoByRoute: true,
                                            fastGeozone: true,
                                        },
                                        props: {
                                            sectionInfoByRoute: (route) => ({
                                                unitId: +route.params?.unitId,
                                                time: Date.now()
                                            })
                                        },
                                        components: {
                                            sectionInfoByRoute: () => import('@/components/geoitems/geozones/sectionInfo/FastGeozoneEdit.vue'),
                                        }
                                    },
                                    {
                                        path: ':type(parking|driving)?/:trackXid?/:timeFrom(\\d+)?/:timeTo(\\d+)?/:trackColor(track-color)?/:speed(\\d+)?',
                                        name: consts.routerNames.units.type.xlink.track,
                                        meta: {
                                            unitTracking: false,
                                            mainRouteName: consts.routerNames.units.main,
                                            parentRouteName: consts.routerNames.units.type.xlink.date,
                                            layers: {
                                                ...consts.defaultSettingsLayers,
                                                units: {visible: false, showInList: true, showLayer: true},
                                                geoitems: {visible: false, showInList: true, showLayer: true},
                                                tracks: {visible: true, showInList: false, showLayer: true},
                                            }
                                        },
                                        props: {},
                                        components: {},
                                        children: []
                                    },
                                    {
                                        path: 'shared-links',
                                        name: consts.routerNames.units.type.xlink.sharedLinks,
                                        meta: {
                                            mainRouteName: consts.routerNames.units.main,
                                            parentRouteName: consts.routerNames.units.type.xlink.date,
                                            blockingRoutesTransitionFromOutside: true,
                                            sectionPopupByRoute: {
                                                SectionWrapByRoutePopup: {
                                                    titlePosition: 'center',
                                                }
                                            }
                                        },
                                        props: {
                                            sectionPopupByRoute: (route) => ({
                                                wrapper: 'EditWizard',
                                                class: 'popup-body',
                                                unitId: route.params.unitId ? +route.params.unitId : undefined,
                                            })
                                        },
                                        components: {
                                            sectionPopupByRoute: () => import('@/components/units/shared-links/WizardSharedLinks.vue'),
                                        }
                                    },
                                    // {
                                    //     path: 'analytics',
                                    //     name: consts.routerNames.units.type.xlink + '.analytics',
                                    //     meta: {
                                    //         mainRouteName: consts.routerNames.units.main,
                                    //         parentRouteName: consts.routerNames.units.type.xlink,
                                    //         pageClass: 'section-unit-links-lab section-unit-links-lab-analytics map-bottom-right',
                                    //     },
                                    //     props:{
                                    //         analytics: (route) => ({
                                    //             unitId: +route.params.unitId
                                    //         }),
                                    //         sectionInfoByRoute: (route) => ({
                                    //             unitId: +route.params.unitId,
                                    //         })
                                    //     },
                                    //     components: {
                                    //         analytics: () => import('@/components/units/info/UnitInfo_station_analytics.vue'),
                                    //         sectionInfoByRoute: () => import('@/components/units/sectionInfo/UnitEdit.vue'),
                                    //     }
                                    // }
                                ]
                            },
                        ]
                    },
                    {
                        path: ':template(obd)/:obdControl(on)?',
                        name: consts.routerNames.units.type.obd.main,
                        redirect: to => {
                            return {
                                name: consts.routerNames.units.type.obd.date,
                                params: {
                                    ...to.params,
                                    date: store.getters.getDateToday,
                                }
                            }
                        },
                        meta: {
                            mainRouteName: consts.routerNames.units.main,
                            parentRouteName: consts.routerNames.units.main,
                            pageClass: 'unit-obd',
                            showMapInfo: false,
                            weatherInMap: true,
                        },
                        props: {
                        },
                        components: {
                            default: () => import('@/components/routeView.vue'),
                        },
                        children:[
                            {
                                path: ':date(\\d{4}-\\d{2}-\\d{2})',
                                name: consts.routerNames.units.type.obd.date,
                                meta: {
                                    mainRouteName: consts.routerNames.units.main,
                                    parentRouteName: consts.routerNames.units.type.obd.main,
                                },
                                props: {
                                    default: (route) => ({
                                        unitId: +route?.params?.unitId,
                                        date: route?.params?.date,
                                    }),
                                },
                                components: {
                                    default: () => import('@/components/units/requestsComponents/requestsByDate_obd.vue'),
                                },
                                children: [
                                    {
                                        path: 'event/:eventXid',
                                        name: consts.routerNames.units.type.obd.event,
                                        meta: {
                                            mainRouteName: consts.routerNames.units.type.obd.main,
                                            parentRouteName: consts.routerNames.units.type.obd.date,
                                            unitTracking: false,
                                            layers: {
                                                ...consts.defaultSettingsLayers,
                                                units: {visible: false, showInList: false, showLayer: false},
                                                geoitems: {visible: false, showInList: true, showLayer: true},
                                                notifications: {visible: true, showInList: false, showLayer: true},
                                            }
                                        },
                                        props: {
                                        },
                                        components: {
                                        },
                                    },
                                    {
                                        path: 'track/:type(parking|driving)?/:trackXid?/:timeFrom(\\d+)?/:timeTo(\\d+)?/:trackColor(track-color)?/:speed(\\d+)?',
                                        name: consts.routerNames.units.type.obd.track,
                                        redirect: to => {
                                            return {
                                                name: consts.routerNames.units.type.xtrack.track,
                                                params: {
                                                    ...to.params,
                                                    template: 'xtrack',
                                                }
                                            }
                                        },
                                    },
                                    {
                                        path: 'edit',
                                        name: consts.routerNames.units.type.obd.edit,
                                        meta: {
                                            mainRouteName: consts.routerNames.units.main,
                                            parentRouteName: consts.routerNames.units.type.obd.date,
                                            blockingRoutesTransitionFromOutside: true,
                                            sectionInfoByRoute: true,
                                        },
                                        props: {
                                            sectionInfoByRoute: (route) => ({
                                                unitId: +route.params.unitId,
                                                time: Date.now(),
                                            })
                                        },
                                        components: {
                                            sectionInfoByRoute: () => import('@/components/units/unit-edit/UnitEdit.vue'),
                                        }
                                    },
                                    {
                                        path: 'info',
                                        name: consts.routerNames.units.type.obd.info,
                                        meta: {
                                            mainRouteName: consts.routerNames.units.main,
                                            parentRouteName: consts.routerNames.units.type.obd.date,
                                            sectionInfoByRoute: true,
                                        },
                                        props: {
                                            sectionInfoByRoute: (route) => ({unitId: +route.params.unitId})
                                        },
                                        components: {
                                            sectionInfoByRoute: () => import('@/components/units/sectionInfo/UnitInfo.vue'),
                                        }
                                    },
                                    {
                                        path: 'fast-geozone',
                                        name: consts.routerNames.units.type.obd.fastGeozone,
                                        meta: {
                                            mainRouteName: consts.routerNames.units.main,
                                            parentRouteName: consts.routerNames.units.type.obd.date,
                                            blockingRoutesTransitionFromOutside: true,
                                            sectionInfoByRoute: true,
                                            fastGeozone: true,
                                        },
                                        props: {
                                            sectionInfoByRoute: (route) => ({
                                                unitId: +route.params?.unitId,
                                                time: Date.now()
                                            })
                                        },
                                        components: {
                                            sectionInfoByRoute: () => import('@/components/geoitems/geozones/sectionInfo/FastGeozoneEdit.vue'),
                                        }
                                    },
                                    {
                                        path: 'shared-links',
                                        name: consts.routerNames.units.type.obd.sharedLinks,
                                        meta: {
                                            mainRouteName: consts.routerNames.units.main,
                                            parentRouteName: consts.routerNames.units.type.obd.date,
                                            blockingRoutesTransitionFromOutside: true,
                                            sectionPopupByRoute: {
                                                SectionWrapByRoutePopup: {
                                                    titlePosition: 'center',
                                                }
                                            }
                                        },
                                        props: {
                                            sectionPopupByRoute: (route) => ({
                                                wrapper: 'EditWizard',
                                                class: 'popup-body',
                                                unitId: route.params.unitId ? +route.params.unitId : undefined,
                                            })
                                        },
                                        components: {
                                            sectionPopupByRoute: () => import('@/components/units/shared-links/WizardSharedLinks.vue'),
                                        }
                                    },
                                ]
                            },
                        ],
                    },
                    {
                        path: ':template(xbles)',
                        name: consts.routerNames.units.type.xbles.main,
                        redirect: to => {
                            return {
                                name: consts.routerNames.units.type.xbles.date,
                                params: {
                                    ...to.params,
                                    date: store.getters.getDateToday,
                                }
                            }
                        },
                        meta: {
                            mainRouteName: consts.routerNames.units.main,
                            parentRouteName: consts.routerNames.units.main,
                            pageClass: 'unit-xbles',
                            showMapInfo: false,
                            weatherInMap: true,
                        },
                        props: {
                        },
                        components: {
                            default: () => import('@/components/routeView.vue'),
                        },
                        children:[
                            {
                                path: ':date(\\d{4}-\\d{2}-\\d{2})',
                                name: consts.routerNames.units.type.xbles.date,
                                meta: {
                                    mainRouteName: consts.routerNames.units.main,
                                    parentRouteName: consts.routerNames.units.type.xbles.main,
                                },
                                props: {
                                    default: (route) => ({
                                        unitId: +route?.params?.unitId,
                                        date: route?.params?.date,
                                    }),
                                },
                                components: {
                                    default: () => import('@/components/units/requestsComponents/requestsByDate_xbles.vue'),
                                },
                                children: [
                                    {
                                        path: 'event/:eventXid',
                                        name: consts.routerNames.units.type.xbles.event,
                                        meta: {
                                            mainRouteName: consts.routerNames.units.type.xbles.info,
                                            parentRouteName: consts.routerNames.units.type.xbles.date,
                                            unitTracking: false,
                                        },
                                        props: {
                                        },
                                        components: {
                                        },
                                    },
                                    {
                                        path: 'track/:type(parking|driving)?/:trackXid?/:timeFrom(\\d+)?/:timeTo(\\d+)?/:trackColor(track-color)?/:speed(\\d+)?',
                                        name: consts.routerNames.units.type.xbles.track,
                                        meta: {
                                            unitTracking: false,
                                            mainRouteName: consts.routerNames.units.main,
                                            parentRouteName: consts.routerNames.units.type.xbles.date,
                                            layers: {
                                                ...consts.defaultSettingsLayers,
                                                units: {visible: false, showInList: true, showLayer: true},
                                                geoitems: {visible: false, showInList: true, showLayer: true},
                                                tracks: {visible: true, showInList: false, showLayer: true},
                                            }
                                        },
                                        props: {},
                                        components: {},
                                        children: []
                                    },
                                    {
                                        path: 'map-info',
                                        name: consts.routerNames?.units?.type?.xbles?.map_info?.main,
                                        meta: {
                                            mainRouteName: consts.routerNames?.units?.type?.xbles?.info,
                                            parentRouteName: consts.routerNames?.units?.type?.xbles?.date,
                                            // pageClass: 'prometheus-portal__xbles prometheus-portal__xbles-id',
                                        },
                                        props: {
                                            default: (route) => ({
                                                unitId: route?.params?.unitId
                                            })
                                        },
                                        components: {
                                            default: () => import('@/components/units/info/xbles/UnitInfo_xbles_map_info.prometheus.vue'),
                                        },
                                    },
                                    {
                                        path: ':tagId',
                                        name: consts.routerNames?.units?.type?.xbles?.id?.main,
                                        meta: {
                                            mainRouteName: consts.routerNames?.units?.type?.xbles?.info,
                                            parentRouteName: consts.routerNames?.units?.type?.xbles?.date,
                                            // pageClass: 'prometheus-portal__xbles prometheus-portal__xbles-id',
                                        },
                                        props: {
                                        },
                                        components: {
                                        },
                                    },
                                    {
                                        path: 'edit',
                                        name: consts.routerNames.units.type.xbles.edit,
                                        meta: {
                                            mainRouteName: consts.routerNames.units.main,
                                            parentRouteName: consts.routerNames.units.type.xbles.date,
                                            blockingRoutesTransitionFromOutside: true,
                                            sectionInfoByRoute: true,
                                        },
                                        props: {
                                            sectionInfoByRoute: (route) => ({
                                                unitId: +route.params.unitId,
                                                time: Date.now(),
                                            })
                                        },
                                        components: {
                                            sectionInfoByRoute: () => import('@/components/units/unit-edit/UnitEdit.vue'),
                                        }
                                    },
                                    {
                                        path: 'info',
                                        name: consts.routerNames.units.type.xbles.info,
                                        meta: {
                                            mainRouteName: consts.routerNames.units.main,
                                            parentRouteName: consts.routerNames.units.type.xbles.date,
                                            sectionInfoByRoute: true,
                                        },
                                        props: {
                                            sectionInfoByRoute: (route) => ({unitId: +route.params.unitId})
                                        },
                                        components: {
                                            sectionInfoByRoute: () => import('@/components/units/sectionInfo/UnitInfo.vue'),
                                        }
                                    },
                                    {
                                        path: 'shared-links',
                                        name: consts.routerNames.units.type.xbles.sharedLinks,
                                        meta: {
                                            mainRouteName: consts.routerNames.units.main,
                                            parentRouteName: consts.routerNames.units.type.xbles.date,
                                            blockingRoutesTransitionFromOutside: true,
                                            sectionPopupByRoute: {
                                                SectionWrapByRoutePopup: {
                                                    titlePosition: 'center',
                                                }
                                            }
                                        },
                                        props: {
                                            sectionPopupByRoute: (route) => ({
                                                wrapper: 'EditWizard',
                                                class: 'popup-body',
                                                unitId: route.params.unitId ? +route.params.unitId : undefined,
                                            })
                                        },
                                        components: {
                                            sectionPopupByRoute: () => import('@/components/units/shared-links/WizardSharedLinks.vue'),
                                        }
                                    },
                                ]
                            },
                        ],
                    },
                ],
            },
        ],
        // beforeEnter: (to, from) => {
        //     if(from.name && from.name != 'Login'){// First load not correct getUserStorageKey == 0
        //         let unitsIdPage = {name: 'Units', params: {unitId: localStorage.getItem(store.getters.getUserStorageKey+'.unit.active')}}
        //         if(to.name == 'Units' && !to?.params?.unitId) {
        //             return to?.params?.unitId ? to : unitsIdPage
        //         } else{
        //             return true
        //         }
        //     } else
        //     if(to?.params?.unitId) {// First load
        //         return {...to, params: {}}
        //     }
        // },
        // Vuex version !!!
        // beforeEnter: (to) => {
        //     // let unitId = localStorage.getItem(this.getUserStorageKey + '.unit.active')*1
        //     let unitId = to.params?.unitId
        //     if (!unitId) {
        //         unitId = localStorage.getItem(store.getters.getUserStorageKey+'.unit.active')*1
        //         to.params.unitId = unitId
        //     }
        //     //return false
        // },
    },
];

export default routes